namespace Stores {
    export class CurrentStore {

        private static _current?: Entities.Current;

        static async get(repository: RavenDbClient) {
            if (this._current != null)
                return this._current;

            try {
                const { document: document } = await repository.getDocument<Entities.Current>(Entities.Current.getId());
                this._current = document;
            } catch {
                this._current = new Entities.Current();
            }

            return this._current;
        }

        static async set(repository: RavenDbClient) {
            if (this._current != null)
                await repository.saveDocument(this._current);
        }
    }
}